import React, { useEffect, useState } from 'react';
import { connect, history } from 'umi';

import { Button, Text } from '@digitalc/dxp-ui';
import Header from '@/components/Header';
import errorIconH5 from '@/assets/images/point/imageClp.png';
import useGCPI18n from '@/hooks/useGCPI18n';
import style from './index.less';

const Utm = props => {
  const { dispatch } = props;
  const [iframeUrl, setIframeUrl] = useState('');
  const [showMiddlePage, setShowMiddlePage] = useState(false);
  const str = window.location.pathname?.split('/');
  const targetStr = str[str.length - 1];
  const linkId = targetStr;
  const GCPI18n = useGCPI18n();

  useEffect(() => {
    dispatch({
      type: 'index/getUtmLink',
      payload: { id: linkId },
    }).then(res => {
      if (res) {
        if (!res?.data?.linkUrl) {
          setShowMiddlePage(true);
          return;
        }
        // EDIRECT = "1";IFRAME = "2"; RESPONSE_HTML = "3"; PROXY_DOWNLOAD_FILE = "4";
        if (res?.data?.responseMode === '4' || res?.data?.responseMode === '1') {
          window.location.href = res?.data?.linkUrl;
          // window.location.href = `${res?.data?.linkUrl.replace('http://10.45.80.101:8090', 'http://localhost:8000')}&token=123`;
        } else if (res?.data?.responseMode) {
          setIframeUrl(res?.data?.linkUrl);
          // window.location.href = res?.data?.linkUrl;
        }
      }
    });
  }, []);

  const handleBack = () => {
    if (window.history.length > 1) {
      history.goBack();
    } else {
      window.close();
    }
  };

  if (showMiddlePage) {
    return (
      <div className={style.errorPage}>
        <Header
          title={GCPI18n('lb_page_name')}
          titleColor="#000000"
          goBack={handleBack}
          onlyGoBack
          isHiddenBorder
          breakpoint="Mobile"
          size="NavigationBold"
        />
        <div className={style.errorContent}>
          <div className={style.errorIcon}>
            <img src={errorIconH5} alt="error" />
          </div>

          <div className={style.errorTitle}>
            <Text breakpoint="Mobile" size="TitleT23Bold">
              {GCPI18n('lb_short_link_error_message')}
            </Text>
          </div>
          <div className={style.errorMessage}>
            <Text breakpoint="Mobile" size="ContentC14Regular">
              {GCPI18n('lb_game_unavailable_message')}
            </Text>
          </div>

          <Button type="primary" onClick={handleBack} className={style.backButton}>
            <Text breakpoint="Mobile" size="ContentC15Bold">
              {GCPI18n('lb_cust_detail_modal_back')}
            </Text>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={style.page}>
      <div className={style.container}>
        {iframeUrl && (
          <iframe
            title="preview"
            style={{
              border: 'none',
              width: '100%',
              height: document.documentElement.clientHeight,
              margin: '0 auto',
            }}
            src={iframeUrl}
            id="h5PreviewContent"
          />
        )}
      </div>
    </div>
  );
};

export default connect(() => ({}))(Utm);
